export const USER_INTERESTS = [
  "Technology",
  "AI & Machine Learning",
  "Gaming",
  "Science",
  "Books & Literature",
  "Movies & Cinema",
  "Music",
  "Art & Design",
  "Travel & Adventure",
  "Food & Cooking",
  "Sports & Fitness",
  "Programming",
  "Startups & Entrepreneurship",
  "History",
  "Philosophy",
  "Nature & Outdoors",
  "Photography",
  "Writing",
  "Fashion & Style",
  "Space Exploration",
];

export const DEFAULT_PROFILE_PIC_URL = "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png";
export const DEFAULT_BOT_PLACEHOLDER_IMAGE_URL = "https://static.wikia.nocookie.net/marvelcinematicuniverse/images/9/9d/Iron_Man_Infobox.jpg/revision/latest?cb=20240802142023";
